import ReactGA from 'react-ga4';

import { citiboxData } from '@/hooks/useCitiboxData';
import { getClientContext } from '@/lib/citibox/sdk/clientContext';
import { AnalyticsFromServer } from '@/lib/google/AnalyticsFromServer';
import { AnalyticsProperties } from '@/lib/google/AnalyticsProperties';
import { compactObject, isClient } from '@/lib/utils';

export const analyticsCouriers = new AnalyticsFromServer();

const customerEventPrefix = 'c_webapp_';
const platform = 'web';

/*
 * Read at send time, never at module load. These identifiers are written to localStorage as a flow
 * progresses — the tracking on the tracking screen, the pickup id when the pickup starts — so a
 * snapshot taken when this module is first imported is empty, or holds the previous flow's values
 * (CBX-11267).
 */
const getEventContext = () =>
  compactObject({
    [AnalyticsProperties.TRACKING]: citiboxData.getTracking(),
    [AnalyticsProperties.TRANSACTION_ID]: citiboxData.getTransactionId(),
    [AnalyticsProperties.PICKUP_ID]: citiboxData.getPickupId(),
    [AnalyticsProperties.DROPOFF_ID]: citiboxData.getDropoffId(),
    [AnalyticsProperties.EXPEDITION_ID]: citiboxData.getExpeditionId(),
    [AnalyticsProperties.USER_ID]: citiboxData.getUserId(),
    [AnalyticsProperties.PLATFORM]: platform,
    [AnalyticsProperties.CLIENT_CONTEXT]: getClientContext()
  });

export const sendEvent = (eventName: string, event_type: string, eventParams?: { [key: string]: unknown }): void => {
  if (isClient) {
    ReactGA.event(customerEventPrefix + eventName, {
      event_type: event_type,
      ...getEventContext(),
      ...(eventParams || {})
    });
  }
};

export default sendEvent;
